import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { SpendItem } from "./SpendItem";
import { HierarchicalSpendItem } from "../utils";

interface SpendListProps {
  hierarchicalData: HierarchicalSpendItem[];
  totalValue: number;
  expandedItems: Set<string>;
  onToggleExpand: (itemId: string) => void;
}

export const SpendList = ({
  hierarchicalData,
  totalValue,
  expandedItems,
  onToggleExpand,
}: SpendListProps) => {
  return (
    <Box>
      {/* Header */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        pb={1}
      >
        <Typography variant="h5">Category</Typography>
        <Box width={190}>
          <Typography variant="h5">Estimated Budget</Typography>
        </Box>
      </Stack>

      {/* Hierarchical data - Show only the top item which should be "Total IT" */}
      {hierarchicalData.slice(0, 1).map((item) => (
        <SpendItem
          key={item.id}
          item={item}
          level={0}
          totalValue={totalValue}
          expandedItems={expandedItems}
          onToggleExpand={onToggleExpand}
        />
      ))}
    </Box>
  );
};
